const isLocalhost = window.location.hostname === "localhost";

function getLoginUrl() {
    if (isLocalhost) {
        return "http://localhost:3001/v1/auth/login";
    }
    return "/v1/auth/home";
}

function getCookieName(){
    if(isLocalhost || window.location.hostname.includes === "dev")
        return "dev_pishop_auth_jwt";
    else
        return "pishop_auth_jwt";
}

function redirectToLogin() {
    document.cookie = `${getCookieName()}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
    const loginUrl = getLoginUrl();
    window.location.replace(loginUrl);
}

export { getLoginUrl, redirectToLogin }